var $fe0436b1fbfb0a3c$exports = {};
$fe0436b1fbfb0a3c$exports = {
    "collapse": `\u{3A3}\u{3CD}\u{3BC}\u{3C0}\u{3C4}\u{3C5}\u{3BE}\u{3B7}`,
    "expand": `\u{391}\u{3BD}\u{3AC}\u{3C0}\u{3C4}\u{3C5}\u{3BE}\u{3B7}`
};


export {$fe0436b1fbfb0a3c$exports as default};
//# sourceMappingURL=el-GR.module.js.map
